import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
} from 'ngx-ui-loader';

import { routes } from './app.routes';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

// NgxUiLoader configuration
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#3b82f6',
  bgsOpacity: 0.1,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 20,
  bgsType: SPINNER.ballSpinClockwise,
  fgsColor: '#3b82f6',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 30,
  fgsType: SPINNER.ballSpinClockwise,
  gap: 24,
  logoPosition: POSITION.centerCenter,
  logoSize: 120,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#f9f9f9',
  pbColor: '#3b82f6',
  pbDirection: PB_DIRECTION.rightToLeft,
  pbThickness: 5,
  hasProgressBar: false,
  text: '',
  textColor: '#3b82f6',
  textPosition: POSITION.bottomCenter,
  maxTime: -1,
  minTime: 300,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(
      withInterceptors([apiInterceptor, errorInterceptor]),
      withFetch()
    ),
    provideAnimationsAsync(),
    provideTranslateService({
      fallbackLang: 'en-US',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig).providers!,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        restoreFocus: false,
        disableClose: true,
      },
    },
  ],
};
